<template>
  <div>
    <SkeletonCard v-if="loading"></SkeletonCard>
    <div v-else>
      <LatestAnalysis v-if="!geoData" :data="data"></LatestAnalysis>
      <div class="headSectionIA">
        <span class="name">
          <translate>Topics</translate>
        </span>
          <div class="groupText">
            <span class="first"><translate>Brand attribute analysis. We detect how LLMs describe the brand.</translate></span>
            <div class="second"><translate :translate-params="{
      numberOfPrompts
      }">Analysis based on %{numberOfPrompts} prompts.</translate></div>
          </div>

      </div>
      <div class="iaTabs self-stretch">
        <button
          :class="{'active': tabActive === 'all'}"
          @click="tabActive = 'all'"
        ><translate>Total LLMs</translate></button>
        <div class="separator"></div>
        <button
          v-for="llm in llms" :key="llm"
          :class="{'active': tabActive === llm}"
          @click="tabActive = llm"
        >
          <img :src="getLogoByLLM(llm)" />
        </button>
      </div>
      <div class="rowTopicsResume">
        <div class="box analysis">
          <span class="titleBoxIa"><translate>Analysis of brand issues by sector</translate></span>
          <div class="groupCharts">
            <div class="scale">
              <span><translate>Average of detected attributes</translate></span>
              <ScaleBarTo100 :value="attributeScore"></ScaleBarTo100>
            </div>
            <div class="chart" style="height: 247px">
              <RadarDimensions :chartData="radarData" style="height: 270px"></RadarDimensions>
            </div>
          </div>
        </div>
        <div class="box resume">
          <span class="titleBoxIa"><translate>Summary of topics</translate></span>
          <div class="types">
            <div class="type">
              <span class="text-26 font-semibold">{{ summaryPresent }}</span>
              <div class="tw-flex items-center gap-2">
                <img src="@/assets/img/IAReputation/topic-presents.svg">
                <span class="text-13 font-semibold text-present"><translate>Present</translate></span>
              </div>
              <span class="text-12"><translate>Positive and neutral attributes</translate></span>
            </div>
            <div class="type">
              <span class="text-26 font-semibold">{{ summaryMissing }}</span>
              <div class="tw-flex items-center gap-2">
                <img src="@/assets/img/IAReputation/topic-lost.svg">
                <span class="text-13 font-semibold text-lost"><translate>Lost</translate></span>
              </div>
              <span class="text-12"><translate>Missing attributes</translate></span>
            </div>
            <div class="type">
              <span class="text-26 font-semibold">{{ summaryUndesired }}</span>
              <div class="tw-flex items-center gap-2">
                <img src="@/assets/img/IAReputation/topic-nodeseados.svg">
                <span class="text-13 font-semibold text-unwanted"><translate>Unwanted</translate></span>
              </div>
              <span class="text-12"><translate>Undesirable attributes</translate></span>
            </div>
            <!--<div class="type">
              <span class="text-26 font-semibold">{{ summaryEmerging }}</span>
              <div class="tw-flex items-center gap-2">
                <img src="@/assets/img/IAReputation/topic-noemergentes.svg">
                <span class="text-13 font-semibold text-emerging"><translate>Emerging</translate></span>
              </div>
              <span class="text-12"><translate>New opportunities</translate></span>
            </div>-->
          </div>
        </div>
      </div>

      <div class="box mt-[16px]">
        <div v-for="(group, index) in groupsAttributes" :key="index" class="groupTopics">
          <div class="type">
            <div class="legend">
              <img v-if="index === 'present'" src="@/assets/img/IAReputation/topic-presents.svg" />
              <img v-else-if="index === 'undesired'" src="@/assets/img/IAReputation/topic-nodeseados.svg" />
              <img v-else-if="index === 'missing'" src="@/assets/img/IAReputation/topic-lost.svg" />
              <!--<img v-else-if="index === 'emerging'" src="@/assets/img/IAReputation/topic-noemergentes.svg" />-->
              <span class="flex-1" v-if="index === 'present'"><translate>Present</translate></span>
              <span class="flex-1" v-else-if="index === 'undesired'"><translate>Unwanted</translate></span>
              <span class="flex-1" v-else-if="index === 'missing'"><translate>Lost</translate></span>
              <!--<span class="flex-1" v-else-if="index === 'emerging'"><translate>Emerging</translate></span>-->
              <span class="number">{{ getNumberOfAttributes(index) }}</span>
            </div>
            <span class="help" v-if="index === 'present'"><translate>Positive and neutral topics by sector dimension</translate></span>
            <span class="help"  v-else-if="index === 'undesired'"><translate>Negative topics by sector dimension</translate></span>
            <span class="help" v-else-if="index === 'missing'">
              <translate>Attributes not shown by sector dimension</translate>
              <span v-if="tabActive === 'all'"> en alguno de los LLMs</span>
            </span>
            <!--<span class="help" v-else-if="index === 'emerging'"><translate>New attributes that are not displayed </translate></span>-->
          </div>
          <div class="dimensions">
            <div v-for="(dimension, indexD) in group.dimensions" class="dimension" :key="indexD">
              <span class="name">{{ indexD }}</span>
              <div v-if="index !== 'present'" class="attributes">
                <span class="attribute"
                      v-for="(attr, indexAttr) in group.dimensions[indexD]" :key="indexAttr"
                      :class="{'hidden': !attr}"
                >{{ attr ? attr.name : '' }}
                  <span class="numAttRepetitions" v-if="tabActive === 'all'"> {{ getNumberRepetitionAttr(attr.name, indexD, index) }}</span>
                </span>
              </div>
              <div v-else class="tw-flex flex-col gap-2">
                <div class="attributes">
                  <span class="text-10 "><translate>Positivos</translate></span>
                  <span class="attribute"
                        v-for="(attr, indexAttr) in group.dimensions[indexD].filter(e => e.detected_tone === 'positive')" :key="indexAttr"
                        :class="{'hidden': !attr}"
                  >{{ attr ? attr.name : '' }}
                  <span class="numAttRepetitions" v-if="tabActive === 'all'"> {{ getNumberRepetitionAttr(attr.name, indexD, index) }}</span>
                  </span>
                </div>
                <div class="attributes">
                  <span class="text-10"><translate>Neutros</translate></span>
                  <span class="attribute"
                        v-for="(attr, indexAttr) in group.dimensions[indexD].filter(e => e.detected_tone !== 'positive')" :key="indexAttr"
                        :class="{'hidden': !attr}"
                  >{{ attr ? attr.name : '' }}
                  <span class="numAttRepetitions" v-if="tabActive === 'all'"> {{ getNumberRepetitionAttr(attr.name, indexD, index) }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LatestAnalysis from "@/components/IAReputation/LatestAnalysis.vue"
import MixinIAReputation from "@/mixins/iareputation.js"
import SrvIAReputationService from "@/services/iareputation.js"
import SkeletonCard from '@/components/common/skeletonCard.vue'
import ScaleBarTo100 from "@/components/IAReputation/ScaleBarTo100.vue"
import RadarDimensions from "@/components/IAReputation/RadarDimensions.vue"
export default {
  components: {LatestAnalysis, SkeletonCard, ScaleBarTo100, RadarDimensions},
  mixins: [MixinIAReputation],
  props: ['geoData'],
  data() {
    return {
      data: null,
      loading: false,
      tabActive: 'all',

    }
  },
  async mounted() {
    this.loading = true
    try {
      const processData = (data) => {
        Object.keys(data.aggregated_references.by_type).forEach(type => {
          Object.keys(data.aggregated_references.by_type[type]).map(reference => {
            data.aggregated_references.by_type[type][reference] = {...data.aggregated_references.by_type[type][reference], open: false}
            Object.keys(data.aggregated_references.by_type[type][reference]).map(source => {
              if (source !== 'open') {
                data.aggregated_references.by_type[type][reference][source] = {...data.aggregated_references.by_type[type][reference][source], open: false}
              }
            })
          })
        })
        return data
      }

      if (!this.geoData) {
        const {status, data} = await SrvIAReputationService.getReputation({brand_uuid: this.brandUUID})
        if (status === 200) {
          this.data = processData(data)
        }
      } else {
        this.data = processData(this.geoData)
      }
    } catch (e) {
      console.log(e)
    }
    this.loading = false
  },
  methods: {
    getDimensionsEmpty () {
      return Object.keys(this.data.aggregated_attributes.by_provider['openai'].by_sectoral)
    },
    getNumberOfAttributes (type) {
      if (!this.data) return 0
      let sum = 0
      Object.keys(this.groupsAttributes[type].dimensions).forEach(dimension => {
        sum += this.groupsAttributes[type].dimensions[dimension].length
      })

      return sum
    },
    getNumberRepetitionAttr (attr, dimension, type) {
      if (!this.data || this.tabActive !== 'all') return 0
      let num = 0

      Object.keys(this.data.aggregated_attributes.by_provider).forEach(llm => {
        num += this.data.aggregated_attributes.by_provider[llm].by_sectoral[dimension].lists[type].filter(e => e.name === attr).length
      })

      return num

    }
  },
  computed: {
    radarData () {
      if (!this.data) return {labels: [], datasets: []}
      let dimensions = Object.keys(this.data.aggregated_attributes.summary.by_sectoral)
      let dataDimensions
      let colors
      if (this.tabActive === 'all') {
        dataDimensions = Object.keys(this.data.aggregated_attributes.summary.by_sectoral).map( e => this.data.aggregated_attributes.summary.by_sectoral[e].scores.attributes_score.toFixed(0))
        colors = Object.keys(this.data.aggregated_attributes.summary.by_sectoral).map( e => this.getColorByAttributesScore(this.data.aggregated_attributes.summary.by_sectoral[e].scores.attributes_score))
      } else {
        dataDimensions = Object.keys(this.data.aggregated_attributes.by_provider[this.tabActive].by_sectoral).map( e => this.data.aggregated_attributes.by_provider[this.tabActive].by_sectoral[e].scores.attributes_score.toFixed(0))
        colors = Object.keys(this.data.aggregated_attributes.by_provider[this.tabActive].by_sectoral).map( e => this.getColorByAttributesScore(this.data.aggregated_attributes.by_provider[this.tabActive].by_sectoral[e].scores.attributes_score))
      }

      return {
        labels: dimensions,
        datasets: [
          {
            label: 'Puntuación',
            data: dataDimensions,
            backgroundColor: 'rgba(138, 123, 201, 0.3)',
            borderWidth: 0,
            pointBackgroundColor: colors,
            pointBorderColor: '#fff',
            pointBorderWidth: 0,
            pointRadius: 6,
            pointHoverRadius: 8
          }
        ]
      }
    },
    attributeScore () {
      if (!this.data) return 0
      if (this.tabActive === 'all') {
        return this.data.aggregated_attributes.summary.overall_scores.attributes_score
      } else {
        return this.data.aggregated_attributes.by_provider[this.tabActive].totals.scores.attributes_score
      }
    },
    summaryPresent () {
      return this.summary?.present || 0
    },
    summaryMissing () {
      return this.summary?.missing || 0
    },
    summaryUndesired () {
      return this.summary?.undesired || 0
    },
    summaryEmerging () {
      return this.summary?.emerging || 0
    },
    summary () {
      if (!this.data) return null
      if (this.tabActive === 'all') {
        return this.data.aggregated_attributes.summary.counts
      } else {
        return this.data.aggregated_attributes.by_provider[this.tabActive].totals.counts
      }
    },
    groupsAttributes () {
      if (!this.data) return null
      //const dimensions = this.getDimensionsEmpty()
      const keysTypes = { 'present': {dimensions: {}}, 'undesired': {dimensions: {}}, 'missing': {dimensions: {}}}
      if (this.tabActive === 'all') {
        Object.keys(keysTypes).forEach((type) => {
          this.llms.forEach(llm => {
            Object.keys(this.data.aggregated_attributes.by_provider[llm].by_sectoral).forEach(dimension => {
              if (!Object.keys(keysTypes[type].dimensions).includes(dimension)) {
                keysTypes[type].dimensions[dimension] = []
              }

              const newItems = this.data.aggregated_attributes.by_provider[llm].by_sectoral[dimension].lists[type];
              keysTypes[type].dimensions[dimension] = keysTypes[type].dimensions[dimension].concat(
                newItems.filter(item => !keysTypes[type].dimensions[dimension].some(x => x.name == item.name))
              );
              })

              })
          })

      } else {
            Object.keys(this.data.aggregated_attributes.by_provider[this.tabActive].by_sectoral).forEach(dimension => {
              Object.keys(keysTypes).forEach((type) => {
                if (!Object.keys(keysTypes[type].dimensions).includes(dimension)) {
                  keysTypes[type].dimensions[dimension] = []
                }
                keysTypes[type].dimensions[dimension] = this.data.aggregated_attributes.by_provider[this.tabActive].by_sectoral[dimension].lists[type]
              })


            })
      }

      return keysTypes
    },
    numberOfPrompts () {
      if (!this.data) return 0
      return this.data.reputation_index['openai'].prompts_answers.direct.length
    }
  }
}
</script>
<style lang="scss">
.separator{
  border-right: 1px solid #D0CFD1;

}
.groupCharts{
  display: grid;
  grid-template-columns: 1fr 1fr;
  .scale{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    font-size: 14px;
    margin-right: 22px;
  }
  .chart{
    canvas{
      height: 274px;
    }
  }
}
.rowTopicsResume{
  display: grid;
  grid-template-columns: minmax(0,6fr) minmax(0,4fr);
  gap: 1rem;
  .resume{
    .types {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr 1fr;
      gap: 1rem;
      margin-top: 29px;
      .type{
        padding: 26px 0 20px 0;
        background-color: #F2F2F2;
        border-radius: 8px;
        align-items: center;
        justify-content: center;
        display: flex;
        flex-direction: column;
      }
    }
  }
}

.groupTopics{
  margin-bottom: 25px;
  .type{
    display: flex;
    gap: 1rem;
    align-items: center;
    .legend{
      background-color: #DCD4F6;
      border-radius: 8px;
      font-size: 13px;
      align-items: center;
      padding: 5px;
      display: flex;
      gap: 1rem;
      .number{
        background-color: #fff;
        border-radius: 100%;
        font-size: 11px;
      }
    }
    .help{
      color: #AFAAAA;
      font-size: 12px;
    }

  }
  .dimensions{
    display: grid;
    grid-template-columns: minmax(0,1fr) minmax(0,1fr) minmax(0,1fr) minmax(0,1fr) minmax(0,1fr);
    gap: 1rem;
    margin-top: 16px;
    .dimension {
      border: 0;
      text-align: left;
      padding: 0;
      .name {
        font-size: 12px;
      }

      .attributes {
        background-color: #F2F2F2;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        padding: 10px 15px;
        gap: 0.5rem;


        .attribute {
          background-color: #fff;
          font-size: 11px;
          border-radius: 8px;
          width: max-content;
          padding: 2.5px 8px;
          max-width: 100%;
          position: relative;
          display: flex;
          gap: 1rem;
          align-items: start;
          .numAttRepetitions{
            color: #000;
            border-radius: 100%;
            background-color: #f2f2f2;
            padding: 2px;
            display: flex;
            text-align: center;
            width: max-content;
            justify-content: center;
            min-width: 16px;
          }
        }
      }
    }
  }
}
</style>
